import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { createRootRoute, Outlet, useRouterState } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';

function Root(): React.JSX.Element {
  const path = useRouterState({ select: (s) => s.location.pathname });

  // NOT ON A FULL-BLEED BUILDER SURFACE. `/preview/{token}` is the thing an author SCANS WITH A
  // PHONE; the editor (`…/edit`) has the palette's `Advanced` header in the bottom-left. Both are
  // exactly where TanStack's `position: fixed` bottom-left badge lands — and on the editor it
  // INTERCEPTS THE CLICK, so `video`/`progress`/`custom`/`repeat` were unreachable in a dev build.
  // Dev-only was not a narrow enough rule: these pages are user-facing *in dev*, the only place
  // they are ever used.
  const isBuilderSurface = path.startsWith('/preview/') || path.endsWith('/edit');

  return (
    <>
      <div className="min-h-screen bg-background">
        <Outlet />
      </div>
      {import.meta.env.DEV && !isBuilderSurface && (
        <>
          <TanStackRouterDevtools />
          <ReactQueryDevtools initialIsOpen={false} />
        </>
      )}
    </>
  );
}

export const Route = createRootRoute({ component: Root });
